import { industriesData } from "@/mocks/homeData";

export default function IndustriesSection() {
  return (
    <section id="industries" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Expertise
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {industriesData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {industriesData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {industriesData.industries.map((industry) => (
            <div
              key={industry.name}
              className="flex items-start gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all group"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                <i className={`${industry.icon} text-xl text-accent-500`} />
              </div>
              <div>
                <h4 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-1">
                  {industry.name}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}